import { createHook, createStore, type StoreActionApi } from 'react-sweet-state';

type State = {
	selectedUserId: string | null;
};

const initialState = {
	selectedUserId: null,
};

const actions = {
	selectUser:
		(userId: string) =>
		({ setState }: StoreActionApi<State>) => {
			setState({ selectedUserId: userId });
		},
} as const;

type Actions = typeof actions;

const ReportingLinesStore = createStore<State, Actions>({
	initialState,
	actions,
});

export const useReportingLinesStore = createHook(ReportingLinesStore);
